import { DefaultError } from 'errors/DefaultError';
import { ErrorObject } from 'ajv';
const formatJson = (object) => JSON.stringify(object, null, 2);
const formatErrors = (errors) => errors.map((e) => e.message).join('\n');

export class SchemaValidationError extends DefaultError {
  errors: { message: string }[];
  constructor({
    title,
    message,
    payload,
    schema,
    ajvErrors = []
  }: {
    title: string;
    message: string;
    payload: Record<string, unknown>;
    schema: Record<string, unknown>;
    ajvErrors?: ErrorObject[];
  }) {
    const errors = ajvErrors.map(({ message, instancePath }) => ({
      message: `${instancePath} ${message}`
    }));

    super({
      name: SchemaValidationError.name,
      title,
      message,
      error: new Error(`The payload:\n ${formatJson(payload)} 
                        \ndoes not match the schema:
                        \n${formatJson(schema)} 
                        \n${formatErrors(errors)}`)
    });

    this.errors = errors;
  }
  static get name() {
    return 'SchemaValidationError';
  }
}
